import { useQuery, useQueryClient, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import ApiError from '../utils/ApiError';

async function updateNewsStatus(lastViewedAt) {
  const response = await fetch(`/api/news/status`, {
    method: 'POST',
    body: JSON.stringify({
      lastViewedAt,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const responseBody = await response.json();
  if (!response.ok) throw new ApiError(responseBody.message, response.status);
  return responseBody;
}

export function useUpdateNewsStatus() {
  const queryClient = useQueryClient();
  return useMutation(updateNewsStatus, {
    onError: (error) =>
      toast(error.message ?? 'Failed to update news status.', {
        type: 'error',
      }),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries('news-status');
    },
  });
}

async function fetchNewsStatus() {
  const response = await fetch('/api/news/status');
  const responseBody = await response.json();
  if (!response.ok) throw new ApiError(responseBody.message, response.status);
  return responseBody;
}

export default function useNewsFeed() {
  return useQuery('news-status', fetchNewsStatus, {
    onError(error) {
      toast(error.message, { type: 'error' });
    },
  });
}
